import axios from "axios";
import { getEnv } from "../utils";
import { ServerErrorException, ValidationException, TokenInvalidoException, PermissaoException, ClientErrorException } from "./exceptions";
import * as exceptions from "./exceptions";
import { getBase } from "../services/api";

const api_inventario = axios.create({ baseURL: getEnv('VUE_APP_API_INVENTARY_URL') });
api_inventario.interceptors.request.use(async config => {
    const token = getInventarioToken();
    if (token) {
        config.headers.Authorization = `Basic ${token}`;
        let bases = {
            "sp": "MATRIZ",
            "ba": "BA",
            "ex": "EXTREMA",
            "es": "ES",
            "stg": "HK",
            "itajai": "ITAJAI",
            "jundiai": "JUNDIAI",
            "ma": "MARANHAO",                                                           
            "sbc": "SBC",
            "contagem": "CONTAGEM",
            "camacari": "CAMACARI",
            "rio" : "RJ"
        };

        config.headers.Base = bases[getBase()];
    }
    return config;
});

api_inventario.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    let exception;
    let response = error.response;

    if (response) {
        let status = response.status;

        if (status >= 400 || status <= 499) {

            if (status == 401) {
                exception = new TokenInvalidoException();
            } else if (status == 403) {
                exception = new PermissaoException();
            } else {
                var data = response.data;
                if (data.exception) {
                    switch (data.exception) {
                    case "ValidationException":
                        exception = new ValidationException(data.errors, data.errorMessage || data.message || "");
                        break;
                    case "UnexpectedValueException":
                        exception = new ClientErrorException(data.errorMessage || data.message || "");
                        break;
                    default:
                        exception = new exceptions[data.exception](data.errorMessage || null);
                    }
                } else {
                    exception = new ClientErrorException(data.errorMessage || null);
                }
            }

        } else {
            exception = new ServerErrorException(data.errorMessage || null);
        }
    }


    return Promise.reject(exception || error);
});

export default api_inventario;

export function getInventarioToken() {
    let token = localStorage.getItem('inventario-token');
    return token;
}